var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"c-meeting-section"},[_c('h4',{staticClass:"bc-caption-upper c-meeting-section__headline"},[_c('span',[_vm._v(_vm._s(_vm.title))]),(_vm.subtitle)?_c('span',[_vm._v(_vm._s(_vm.subtitle))]):_vm._e()]),_c('div',{staticClass:"c-meeting-section__items"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }